import {useField} from 'formik';
import {useCallback, useMemo} from 'react';

import {TextAreaProps, TextArea} from './TextArea';

type Props = {
    name: string;
} & Partial<TextAreaProps>;

export const TextAreaFormik: React.FC<Props> = ({
    name,
    label,
    required,
    ...rest
}: Props) => {
    const [field, meta, helper] = useField(name);

    const hasError = useMemo<boolean>(
        () => meta.error && (meta.touched || meta.value) || meta.touched && required && !meta.value,
        [meta, required]
    );

    const onBlurHandler = useCallback((e: React.FocusEvent) => {
        const {value} = e.currentTarget as HTMLTextAreaElement;
        field.onBlur(e);
        helper.setValue(value);
    }, [field, helper]);

    const onChangeHandler = useCallback((value: string) => {
        helper.setValue(value);
    }, [helper]);

    return (
        <TextArea
            {...rest}
            name={name}
            label={label}
            value={field.value}
            required={required}
            hasError={hasError}
            errorMessage={meta.error}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
        />
    );
};